module.exports = __webpack_public_path__ + "static/img/STL_H5.df94590.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/company-logo/STL_H5.png
// module id = AEij
// module chunks = 34